import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import config from 'config';
import { msg } from 'api';

import FeedbackForm from '../containers/FeedbackForm';
import FeedbackSuccess from './FeedbackSuccess';
import Modal from 'widgets/Modal/Modal';

const FeedbackModalTitle = (isFeedbackSent) => (
  <div className="fp-feedbackHeading">
    <p className={
      classNames(
        'fp-feedbackHeading__title',
        { 'fp-feedbackHeading__title--success': isFeedbackSent }
      )}
    >
      {isFeedbackSent ? msg.feedbackPopup.sentTitle : msg.feedbackPopup.title}
    </p>
  </div>
);

const FeedbackModal = ({
  closeModal,
  isFeedbackSent,
}) => (
  <Modal
    withoutHeader={!config.feedbackPopup.withHeader}
    onCancel={closeModal}
    title={FeedbackModalTitle(isFeedbackSent)}
    className="fp-feedbackPopup"
  >

    <div className={
      classNames(
        'fp-feedbackPopup__modalContainer',
        { 'u-hidden': isFeedbackSent }
      )}
    >
      <div className="fp-feedbackPopup__infoBox">
        <p className="fp-feedbackPopup__infoTitle">
          {msg.feedbackPopup.changelogHeader}
        </p>
        <ul className="fp-feedbackPopup__infoList">
          {msg.feedbackPopup.changelog.map(
            change => (
              <li
                className="fp-feedbackPopup__change"
                key={change}
              >
                {change}
              </li>
            )
          )}
        </ul>
      </div>

      <div className="fp-feedbackPopup__formBox">
        {msg.feedbackPopup.formTitle && (
          <p className="fp-feedbackPopup__formTitle">
            {msg.feedbackPopup.formTitle}
          </p>
        )}
        <FeedbackForm />
      </div>
    </div>

    {/*
      Different retailers have different approach to styling headers and feedback success message.
      If modal has header, success message is put inside header
      If modal has no header, we're dealing with another retailer,
        so success message will be displayed in modals body.
    */}
    {isFeedbackSent && !config.feedbackPopup.withHeader &&
      <FeedbackSuccess handleCloseButtonClick={closeModal} />
    }
  </Modal>
);

FeedbackModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  isFeedbackSent: PropTypes.bool.isRequired,
};

export default FeedbackModal;
